import { derived, writable } from 'svelte/store'

// HINT: Knip flags unused export (because it is currently not used)
// TODO: export when needed
const locale = writable('de')
let translation: null | Record<string, string> = null

/**
 * Interpolation values for `{{key}}` placeholders in property strings.
 *
 * Typing `vars` (b5180beca3, was implicit any) exposed 86 call sites passing a
 * literal `[]` — the `translate('de', KEY, [])` yup-message idiom, a runtime
 * no-op; all fixed by dropping the argument. Do NOT widen this type back to
 * accept arrays (i18n.test.ts pins that with a @ts-expect-error tripwire).
 */
export type TranslationVars = Record<string, string | number>

export async function loadTranslation(devMode: boolean = false) {
	// this is necessary to be able to resolve the translations from storybook
	// for production mode, the links are redirected correctly by vite, however, for dev mode, we fetch hardcoded via localhost
	const url = devMode ? 'http://localhost:9000/api/i18n' : '/api/i18n'
	const response = await fetch(url)
	const data = await response.json()
	translation = data.data
}

export async function requireI18n(callback: () => void) {
	if (translation === null) {
		await loadTranslation()
		callback()
	} else {
		callback()
	}
}

export function translate(locale: string, key: string, vars: TranslationVars = {}) {
	// Let's throw some errors if we're trying to use keys/locales that don't exist.
	// We could improve this by using Typescript and/or fallback values.
	if (!key) throw new Error('no key provided to $t()')
	if (!locale) throw new Error(`no translation for key "${key}"`)

	// Grab the translation from the translations object.
	if (translation == null) {
		return key
	}
	let text = translation[key]

	// if (!text) throw new Error(`no translation found for ${locale}.${key}`);
	if (!text) return key

	// Replace any passed in variables in the translation string.
	Object.keys(vars).map((k) => {
		const regex = new RegExp(`{{${k}}}`, 'g')
		text = text.replace(regex, String(vars[k]))
	})

	return text
}

export const t = derived(
	locale,
	($locale) =>
		(key: string, vars: TranslationVars = {}) =>
			translate($locale, key, vars)
)
